export * from './FirstWar'
export * from './SecondWar'

export const worldWaritems = {
	'Primera guerra mundial': {
		path: '/sociales/guerras-mundiales/primera-guerra',
	},
	'Segunda guerra mundial': {
		path: '/sociales/guerras-mundiales/segunda-guerra',
	},
}
